"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = (e) => {
    var _a, _b, _c;
    const questionId = e.data.questionId;
    if (!questionId)
        return;
    if (!e.data)
        return;
    if (typeof window.ctConstants === 'undefined') {
        console.error(`ctConstant not available`);
        return;
    }
    const analyticsEvent = {};
    window.digitalData.component = [];
    window.digitalData.component.push({
        componentInfo: {
            componentID: '',
            componentName: e.data.component || '',
        },
        attributes: {
            position: '',
            variants: '',
            quizInfo: e.data.quizInfo || '', //'<Quiz type> - <variant>'
        },
    });
    window.digitalData.component[0].attributes.subattributes = [];
    if (((_b = (_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.subattributes) === null || _b === void 0 ? void 0 : _b.length) > 1) {
        for (let attr of e.data.subattributes) {
            window.digitalData.component[0].attributes.subattributes.push(attr);
        }
    }
    else {
        window.digitalData.component[0].attributes.subattributes.push(Object.assign({}, e.data.subattributes[0]));
    }
    analyticsEvent.eventInfo = {
        type: window.ctConstants.diagtooleve,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.engagement,
    };
    analyticsEvent.subcategory = 'Interest';
    analyticsEvent.action = ((_c = e.data) === null || _c === void 0 ? void 0 : _c.action) ? e.data.action : window.ctConstants.diagtoolcta;
    analyticsEvent.label = `${e.data.label} `; //'Question <number>'
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
